// This is a js representation of the grid breakpoints if js needs to know the breakpoints

export default {
  xs: 0,
  lg: 960,
  xl: 1500,
}
